import React from 'react';
import Grid from '@material-ui/core/Grid';
import Modal from '..';
import './styless.css';

export default function ({
  title,
  subTitle,
  handleCancel,
  handleConfirm,
  textCancel,
  textConfirm,
  open,
  className,
}) {
  return (
    <Modal
      title={title}
      subTitle={subTitle}
      open={open || true}
      style={{ textAlign: 'center' }}
      className={className}
    >
      <Grid container justify="space-between" className="confirmAndCancel">
        <Grid item className="cancel">
          <button
            id="cancel"
            data-testid="modal-cancel"
            style={{ background: '#ffffff' }}
            onClick={handleCancel}
          >
            {textCancel}
          </button>
        </Grid>
        <Grid item className="confirm">
          <button
            id="confirm"
            data-testid="modal-confirm"
            style={{ border: 'none' }}
            onClick={handleConfirm}
          >
            {textConfirm}
          </button>
        </Grid>
      </Grid>
    </Modal>
  );
}
